import React, { ReactElement, ReactNode } from 'react';
import {
  Button, Table, Tbody, Td, Th, Tr,
} from 'idsk-react-components';
import LegislativnyMaterialCreateUpdate
  from '../../../../model/legislativnyMaterial/LegislativnyMaterialCreateUpdate';
import LegMaterialCreateStepEnum
  from '../../../../model/legislativnyMaterial/LegMaterialCreateStepEnum';
import './checkDataTable.scss';
import FilledTableRelatedData3 from './FilledTableRelatedData3';
import FilledTableBasicData2 from './FilledTableBasicData2';
import FilledTablePredkladatel4 from './FilledTablePredkladatel4';

interface Props {
  legislativnyMaterial: LegislativnyMaterialCreateUpdate;
  onChangeStep: (nextStep: LegMaterialCreateStepEnum) => Promise<void>;
  isUpdate?: boolean;
}

const CheckDataTable = ({
  legislativnyMaterial,
  onChangeStep,
  isUpdate = false,
}: Props): ReactElement => {
  const renderFilledData = (): ReactNode => {
    if (isUpdate) {
      return (
        <FilledTablePredkladatel4
          legislativnyMaterial={legislativnyMaterial}
          onChangeStep={onChangeStep}
          isUpdate={isUpdate}
        />
      );
    }
    switch (legislativnyMaterial.activeStep) {
      case LegMaterialCreateStepEnum.RELATED_DATA_3:
        return (
          <FilledTableBasicData2
            legislativnyMaterial={legislativnyMaterial}
            onChangeStep={onChangeStep}
          />
        );
      case LegMaterialCreateStepEnum.PREDKLADATEL_4:
        return (
          <FilledTableRelatedData3
            legislativnyMaterial={legislativnyMaterial}
            onChangeStep={onChangeStep}
          />
        );
      case LegMaterialCreateStepEnum.CHECK_DATA_5:
        return (
          <FilledTablePredkladatel4
            legislativnyMaterial={legislativnyMaterial}
            onChangeStep={onChangeStep}
            isUpdate={isUpdate}
          />
        );
      default:
        return (
          <></>
        );
    }
  };
  return (
    <div className="check-data-table">
      <Table>
        <Tbody>
          <Tr>
            <Th width="30%">Typ materiálu</Th>
            <Td width="60%">{legislativnyMaterial.typ?.nazov}</Td>
            <Td width="10%">
              {!isUpdate && (
                <Button
                  size="small"
                  buttonStyle="link"
                  onClick={() => {
                    onChangeStep(LegMaterialCreateStepEnum.TYP_MATERIALU_1);
                  }}
                >
                  Zmeniť
                </Button>
              )}
            </Td>
          </Tr>
          {renderFilledData()}
        </Tbody>
      </Table>
    </div>
  );
};
export default CheckDataTable;
